export default {
  page_header: {
    title: "Относно",
    description: "Преглед на портала, неговите функции и текуща версия.",
  },

  // Tabs
  tabs: {
    overview_tab: {
      name: "Общ преглед",
      title: "Портал на {laboratoryName}",
      subtitle: "Онлайн достъп до резултати, проби и плащания.",
      description:
        "{laboratoryName} дава на пациентите и лабораторния персонал едно сигурно място за достъп до резултати, управление на проби и проверка на плащания — от всяко устройство, на три езика.",

      version_info: {
        header: "Информация за версията:",
        frontend: "Версия на Frontend: 0.3.3",
        backend: "Версия на Backend: 0.0.1",
      },

      features: {
        header: "Функции и възможности:",

        sample_management: {
          title: "Управление на проби",
          subtitle: "Проследяване на пробата от вземането до крайния резултат.",
        },
        real_time_results: {
          title: "Резултати в реално време",
          subtitle: "Синхронизация в реално време с лабораторните апарати.",
        },
        multilingual_support: {
          title: "Многоезична поддръжка",
          subtitle: "Лесно превключване между английски, български и македонски.",
        },
        secure_authentication: {
          title: "Сигурна автентикация",
          subtitle: "Защитен вход чрез Keycloak — данните ви винаги в безопасност.",
        },
        responsive_design: {
          title: "Респонсивен дизайн",
          subtitle: "Пълна поддръжка на компютър, таблет и телефон.",
        },
        accessibility: {
          title: "Достъпност",
          subtitle: "Съответствие с WCAG 2.1 AA стандарти за достъпност.",
        },
        high_performance: {
          title: "Висока производителност",
          subtitle: "Бързо зареждане дори при голям обем резултати.",
        },
      },

      targetUsers: {
        header: "Потребители на портала:",

        otp_patients: {
          title: "ОТП Пациенти",
          subtitle: "Онлайн достъп до резултати и финансов баланс.",
        },
        lab_technicians: {
          title: "Лабораторни техници",
          subtitle: "Обработка и проверка на постъпващи проби.",
        },
        pathologists: {
          title: "Патологисти и специалисти",
          subtitle: "Преглед и валидация на резултати от различни отдели.",
        },
        lab_administrators: {
          title: "Администратори на лаборатории",
          subtitle: "Наблюдение на натовареността, потребителите и дневните операции.",
        },
      },
    },

    services_tab: {
      name: "Услуги",
      title: "Услуги на LIS Portal",
      subtitle: "Самообслужващ уеб портал за лабораторни резултати и плащания",

      refresh_button: "Обновяване на услугите",
      refreshTooltip: "Обновяване на услугите",
      openApp: "Отваряне на приложение",
      openApiDocs: "OpenAPI документация",
      healthCheck: "Проверка на здравето",
    },

    actions_tab: {
      name: "Действия",
      title: "Действия на портала",
      subtitle: "Управление на кеша и конфигурациите на системата",

      cache_card: {
        title: "Обновяване на кеша",
        content:
          "Обновете кеша от страна на сървъра, за да наложите обновяване на всички данни от базата данни.",
        action: "Обновяване на кеша",
      },
    },

    copyright_tab: {
      name: "Авторски права",
      title: "Авторски права",
      subtitle: "Интелектуална собственост и лицензи",

      description_start: "Всички интелектуални собствености на това приложение принадлежат на ",
      company_name: "SKYWARE Group",
      description_end:
        ". Правата на компонентите и библиотеките, използвани в това приложение, принадлежат на техните автори и са лицензирани подходящо, както е описано по-долу.",
    },

    credits_tab: {
      name: "Заслуги",
      title: "Заслуги",
      subtitle: "Изградено с технологии с отворен код",

      application_title: "Lab Portal",
      authors_of_application: "Автори на това приложение",
      licence: "лиценз",
      et_al: "и други",
    },
  },
};
